import { LeaderboardNav } from "@/components/dashboard/leaderboards/LeaderboardNav";
import { convertLetters } from "@/utils/letterConversion";
import { Outlet } from "react-router-dom";

const LeaderboardLayout: React.FC = () => {
    return (
        <div className="relative min-h-screen overflow-hidden px-4 py-6 sm:px-6 lg:px-8">
            <div className="pointer-events-none absolute inset-0 -z-20 bg-zinc-900" />
            <div
                className="pointer-events-none absolute inset-0 -z-10 bg-center bg-no-repeat opacity-55"
                style={{
                    backgroundImage: "url(/village-map.webp)",
                    backgroundSize: "100% 100%",
                }}
            />
            <div className="pointer-events-none absolute inset-0 -z-10 bg-[linear-gradient(to_bottom,rgba(0,0,0,0.55),rgba(0,0,0,0.62))]" />
            <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(circle_at_top,rgba(255,193,7,0.10),rgba(0,0,0,0.30)_35%,rgba(0,0,0,0.55)_75%)]" />

            <div className="w-full space-y-6">
                <div className="border-brand rounded-2xl border bg-zinc-900/55 px-4 py-5 shadow-2xl sm:px-6">
                    <h1 className="font-prviking text-brand text-3xl sm:text-4xl">
                        {convertLetters("Leaderboards")}
                    </h1>
                    <p className="font-garamond mt-2 text-zinc-300">
                        Track progress across Village VP, season standings, and
                        shield value.
                    </p>
                </div>

                <div className="border-brand rounded-2xl border bg-zinc-900/55 p-4 shadow-2xl sm:p-6">
                    <LeaderboardNav />
                    <div className="mt-6">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeaderboardLayout;
